import styled from "styled-components/native";
import Card from "./card";

const editFormWidth = "900px";

export const FormCard = styled(Card)`
  width: 100%;
  max-width: ${editFormWidth};
`;
